import { Component, OnInit, Input, OnDestroy, EventEmitter, Output } from '@angular/core';
import { Form, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router'; 
import { TranslateService } from '@ngx-translate/core';
import { Contact } from '../../models/Contact';
import { PasswordEmailModel } from '../../models/EmailPasswordChangeModel';
import { GetUserResult, UserValidationChild, XdecryptRequest } from '../../models/UserModel';
import { LoginService } from '../../services/login.service';


@Component({
  selector: 'app-first-login-passwordreset',
  templateUrl: './first-login-passwordreset.component.html',
  styleUrls: ['./first-login-passwordreset.component.css']
})
export class FirstLoginPasswordResetComponent   {

    getDecryptDetails : GetUserResult; 
    showResetPassword : boolean;
    firstloginResetPasswordForm : FormGroup;
    IsPwdLenghtNotCorrect : boolean = false;
    IsPwdRerquired :boolean =false;
    pwdMustMatch : boolean;
    fieldTextType: boolean;
    confirmTieldTextType:boolean;
    defaultLanguage : string;
    userName : string ;
    xecryptRequest : XdecryptRequest;
    passwordResetModel : PasswordEmailModel; 
    displayInvalid : boolean =false ;
    status : string;
    showHeader : boolean = true;
    displayClientSelection : boolean;
    displayClient : boolean ;
    clients : object;
    contact : Contact;
    firstName : string;
    lastName : string;
    nmSoc : string;
    userStatus : string;
    resetPassword : boolean = true;
    public pwdEmailModel: PasswordEmailModel;
    public userDetails : UserValidationChild;
    constructor(
        private route: ActivatedRoute,
        private formBuilder: FormBuilder,   
        private _router: Router,
        private loginService: LoginService,
        private translate: TranslateService,
        )
        {
            this.getDecryptDetails = new GetUserResult();
            this.xecryptRequest = new XdecryptRequest();
            this.passwordResetModel = new  PasswordEmailModel();
            this.contact = new Contact();
            this.pwdEmailModel = new PasswordEmailModel();
            this.userDetails= new UserValidationChild();
        }
      
    ngOnInit()
    {
        this.firstloginResetPasswordForm = this.formBuilder.group({
            userPassword: ['', [Validators.minLength(8)]],
            confirmUserPassword: ['', [Validators.minLength(8)]]
          });

        const userName = this.route.snapshot.queryParams['userName'];
        const flChgPsw = this.route.snapshot.queryParams['flChgPsw'];
        // const timestamp =this.route.snapshot.queryParams['timestamp'];
        const email =this.route.snapshot.queryParams['email'];
        const Languagecode = this.route.snapshot.queryParams['Languagecode'];
            
        //from URL
        this.getDecryptDetails.NmCteUsr =userName;
        // this.getDecryptDetails.FlChgPsw= flChgPsw;
        this.getDecryptDetails.TlAdrEmlUsr = email;
       this.getDecryptDetails.FlgEncData = flChgPsw;
       this.getDecryptDetails.Languagecode= Languagecode;

       if(  userName != undefined &&   email != undefined &&   Languagecode !=undefined )
       {
        this.loginService.DecryptUrlParameters(this.getDecryptDetails).subscribe(
          (data)=>{
                         

              if(data!="Failed")
              {
                         //decrypted values    
                         this.translate.currentLang = data.Languagecode; 
                         if(this.translate.currentLang=="FR")
                         {
                          this.translate.currentLang ="NL"
                         }
                         else{
                          this.translate.currentLang ="FR"
                         }
                         this.changeLanguage();
                         sessionStorage.setItem("token", data.Token);
                  this.getDecryptDetails.NmCteUsr =data.NmCteUsr;
                  // this.getDecryptDetails.FlChgPsw= data.FlChgPsw;
                  this.getDecryptDetails.TlAdrEmlUsr = data.TlAdrEmlUsr;
                  this.userName = data.NmCteUsr;

                  this.loginService.GetUser(data.NmCteUsr).subscribe(
                      (data)=>{
                              if(data.IdUsr!=null )
                              {
                                this.userStatus = data.LbSta;
                                    this.firstName= data.PnmUsr;
                                    this.nmSoc = data.NmSoc;
                                    this.lastName = data.NmUsr + " "+  this.nmSoc;

                                        this.getDecryptDetails.IdUsr= data.IdUsr;
                                        this.getDecryptDetails.FlChgPsw= data.FlChgPsw; // CHANGED To bug fix 
                                         //GetUser Details 
                                         this.pwdEmailModel.UserName = data.NmCteUsr;
      
      this.pwdEmailModel.Email = this.getDecryptDetails.TlAdrEmlUsr;
      this.pwdEmailModel.UID = data.IdUsr;
                                          this.loginService.SetEmail(this.pwdEmailModel).subscribe(
             (data)=>
             {
                if(data=="Success")
                {
                  this.loginService.ChangeUserStatus(this.getDecryptDetails).subscribe(
                      (data)=>{
                                   if(data =="Success")
                                   {
                                       //changed the status to FINAL 
                                      // NEXT TO STORE IN MF
                                      if(this.lastName ==" ")
                                      {
                                        this.lastName= "unknown";
                                      }
                                      this.contact.noIntervenant =  (this.getDecryptDetails.NmCteUsr).substring(3,this.getDecryptDetails.NmCteUsr.length);
                                      this.contact.email = this.getDecryptDetails.TlAdrEmlUsr;
                                      this.contact.titre = 'On line declaration';
                                      this.contact.regimeLinguistique = this.translate.currentLang;
                                      this.contact.nom= this.lastName;
                                      this.contact.prenom = this.firstName;
                                      this.contact.LanguageClient =this.translate.currentLang;
                                      if(this.userStatus=='EMAIL VALIDATION PENDING')
                                      {
                                        this.loginService.GererContact(this.contact).subscribe(
                                          (data)=>
                                          {
                                            if(data!= "Failed" && data.ReturnValue==1)
                                            {
                                               if(this.getDecryptDetails.FlChgPsw)
                                               {
                                                         //  reset page
                                                          this.showResetPassword = true;
                                               }
                                               else{
                                               // redirect to login 
                                               this._router.navigateByUrl('login/app-authentication');
                                               }
                                            }
                                            else{
                                                     this.displayInvalid= true;
                                            }
                                          }
                                         )
                                      }
                                      else{
                                           if(this.getDecryptDetails.FlChgPsw)
                                           {
                                                     //  reset page
                                                      this.showResetPassword = true;
                                           }
                                           else{
                                           // redirect to login 
                                           this._router.navigateByUrl('login/app-authentication');
                                           }
                                      }
                                      
                                      
                                      
                                   }
                      },
                      (err)=>{

                      });
                    }
                    else{
                      this.displayInvalid= true;
                    }
                  });
                              }
                              else{
                                this.displayInvalid= true;
                              }
                      });
                 

              }
          },
      (err)=>{
//error in decrypt details
      });
       }
       else{
        this.userName = sessionStorage.getItem('UN');
        this.status = sessionStorage.getItem('Status');
        if(this.status=='FINAL')
        {
          this.showResetPassword = true;
          this.showHeader  = false;
        }
        
       }
        
              


    }

    ResetFirstLoginPassword()
    {
        if (this.firstloginResetPasswordForm.get('userPassword').value == (null || undefined || '') || this.firstloginResetPasswordForm.get('confirmUserPassword').value == (null || undefined || '')) {
            this.IsPwdRerquired = true;
            return false;
          }
          else
          {
            this.IsPwdRerquired = false;
          }
  
          if (this.firstloginResetPasswordForm.get('userPassword').status == 'INVALID' || this.firstloginResetPasswordForm.get('confirmUserPassword').status == 'INVALID') {
            this.IsPwdLenghtNotCorrect = true;
            return false;
          }
  
          else{
            this.IsPwdLenghtNotCorrect =false;
          }
       
            if(this.passwordMatchValidation())
            {
              this.resetPassword= false;
                           this.loginService.GetUser(this.userName).subscribe(
                               (data)=>{
                                this.resetPassword = false;
                                      if(data!="Failed")    
                                      {
                                        
                                        if(data.IdUsr != this.userName && data.LbSta =="FINAL"  && data.FlChgPsw == true)
                                        {
                                            this.loginService.GetGenaratedPassword(this.userName).subscribe(
                                                (data)=>{
                                                  if(data.TlPsw!=null && data.IntState =="Ok")
                                                  {
                                                      this.xecryptRequest.str= data.TlPsw;
                                                    this.loginService.Xdecrypt(this.xecryptRequest).subscribe(
                                                        (data)=>
                                                        {
                                                            if(data.XDecryptResult != (null||''))
                                                            {
                                                              //Reset the password 
                                                              this.passwordResetModel.UserName = this.userName;
                                                              this.passwordResetModel.Password = data.XDecryptResult;
                                                              this.passwordResetModel.NewPassword = this.firstloginResetPasswordForm.get('userPassword').value;
                                                              this.loginService.ChangePassword(this.passwordResetModel).subscribe(
                                                                (data)=>
                                                                {
                                                                  if(data== true)
                                                                  {
                                                                    this.userDetails.UserName = this.userName;
                                                                    this.userDetails.Password= this.passwordResetModel.NewPassword;
                                                                    this.loginService.IsValidateUser(this.userDetails).subscribe(
                                                                      (data)=>
                                                                      {
                                                                           if(data.Status=="Valid")
                                                                           {
                                                                           this.clients= data.ClientsData;
                                                                           sessionStorage.setItem('Email', data.Email);
                                                                           sessionStorage.setItem("token", data.Token);
                                                                    this.displayClientSelection = false;
                                                                     this.displayClient = true;
                                                                    this.showResetPassword = false;
                                                                    this.displayInvalid = false;
                                                                    sessionStorage.setItem("NoIntervenant", (this.userName).substring(3,this.userName.length));
                                                                  }
                                                                  else
                                                                  {
                                                                    this.displayInvalid = true;
                                                                  }
                                                                });
                                                                  }
                                                                  else{
                                                                    
                                                                    this.displayInvalid = true;
                                                                  }
                                                                },
                                                                (err)=>
                                                                {
                                                                  this.displayInvalid = true;
                                                                });
                                                            }
                                                            else{
                                                                //show error page 
                                                                this.displayInvalid = true;
                                                            }
                                                            },
                                                            (err)=>
                                                            {
                                                              this.displayInvalid = true;
                                                            }
                                                    );
                                                  }
                                                }
                                            );
                                        }
                                      }
                               },
                               (err)=>{
                                this.displayInvalid = true;
                               });

            }
   
    }
    changeLanguage() {

      if (this.translate.currentLang == 'FR') {
        this.defaultLanguage = "NL";
        sessionStorage.setItem("currentlang", "NL")
        sessionStorage.setItem("presentLang", "Even geduld, we zijn uw gegevens aan het laden");
        document.getElementById('languageDropdown').innerHTML = 'FR';
        (<HTMLImageElement>document.getElementById("langlogo")).src = 'assets/Logos/logo-NL.svg';
      } else {
        this.defaultLanguage = "FR";
        sessionStorage.setItem("currentlang", "FR")
        sessionStorage.setItem("presentLang", "Veuillez patienter svp, nous chargeons vos données");
        document.getElementById('languageDropdown').innerHTML = 'NL';
        (<HTMLImageElement>document.getElementById("langlogo")).src = 'assets/Logos/logo-FR.svg';
      }
      this.switchLang(this.defaultLanguage);
  
    }
    switchLang(lang: string) {
      this.defaultLanguage = lang;
      this.translate.use(lang);
  
    }
    passwordMatchValidation() {
        if (this.firstloginResetPasswordForm.get('userPassword').value !== this.firstloginResetPasswordForm.get('confirmUserPassword').value) {
          this.pwdMustMatch = true;
          return false;
        }
        else {
          this.pwdMustMatch = false;
          return true;
        }
      }
      toggleFieldTextType() {
        this.fieldTextType = !this.fieldTextType;
        
      }

      toggleConfirmFieldTextType() {
        
        this.confirmTieldTextType = !this.confirmTieldTextType;
      }
}
